import React, { createContext, useCallback, useContext, useState } from "react";
import { v4 as uuidv4 } from 'uuid';

import ToastContainer from "../Components/Atoms/ToastContainer";

export interface ToastMessage {
  id: string;
  type?: "success" | "error" | "info";
  title: string;
  description?: string;
  linkTo?: string;
  linkLabel?: string;
  duration?: number;
  size?: "normal" | "large";
}

interface ToastContextData {
  addToast(message: Omit<ToastMessage, "id">): void;
  removeToast(id: string): void;
}

const ToastContext = createContext<ToastContextData>({} as ToastContextData);

const ToastProvider: React.FC = ({ children }) => {
  const [messages, setMessages] = useState<ToastMessage[]>([]);
  const addToast = useCallback(
    ({ type, title, description, linkTo, linkLabel, duration, size }: Omit<ToastMessage, "id">) => {
      const id = uuidv4();
      const toast = {
        id,
        type,
        title,
        description,
        linkTo,
        linkLabel,
        duration,
        size,
      };
      setMessages((state) => [...state, toast]);
    },
    []
  );

  const removeToast = useCallback((id: string) => {
    setMessages((state) => state.filter((message) => message.id !== id));
  }, []);

  return (
    <ToastContext.Provider value={{ addToast, removeToast }}>
      {children}
      <ToastContainer messages={messages} />
    </ToastContext.Provider>
  );
};

function useToast() {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used withi a Toast provider");
  }
  return context;
}

export { ToastProvider, useToast };

